/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import can from 'can';
import holeManager from 'scripts/services/hole-manager';
import template from './18-hole.stache';

Component.extend({
    tag: 'leaderboard-18-hole',
    template: template,
    leakScope: false,
    viewModel: {
        sponsor: null,
        define: {
            regularPlayoff: {
                Type: can.Map,
            },
            roundScorecard: {
                Type: can.Map,
                get() {
                    return this.attr('regularPlayoff.players.0.scorecard');
                },
            },
        },
        getScoresOutFilter(holeResult) {
            return holeResult.hole.identifier <= 9;
        },
        getScoresInFilter(holeResult) {
            return holeResult.hole.identifier > 9;
        },
        getHoleResults(scorecard) {
            if (scorecard && scorecard.holeResults) {
                return scorecard.holeResults;
            }
        },
        getScoresIn(scorecard) {
            const holeResults = this.getHoleResults(scorecard);
            if (holeResults) {
                return holeResults.filter(this.getScoresInFilter);
            }
        },
        getScoresOut(scorecard) {
            const holeResults = this.getHoleResults(scorecard);
            if (holeResults) {
                return holeResults.filter(this.getScoresOutFilter);
            }
        },
        getScoreColor(scorecard, hole) {
            return holeManager.getHoleScoreColor(scorecard, hole);
        },
    },
    events: {
        '.s-switcher-btn click': function(e) {
            if (!this.leaderboardTable) {
                this.leaderboardTable = this.element.find(
                    '.s-leaderboard-table',
                );
                this.holeSwitcherButton = this.element.find(
                    '.s-leaderboard-head__hole-switcher .s-switcher-btn',
                );
            }
            if (!can.$(e.context).hasClass('is-selected')) {
                this.holeSwitcherButton.toggleClass('is-selected');
                if (can.$(e.context).attr('data-type') === 'first-half') {
                    this.leaderboardTable
                        .removeClass('is-selected-second-half')
                        .addClass('is-selected-first-half');
                } else {
                    this.leaderboardTable
                        .removeClass('is-selected-first-half')
                        .addClass('is-selected-second-half');
                }
            }
        },
    },
});
